<template lang="html">
    <transition name="move">
    <!-- <div class="returnbutton"> -->
        <div class="returnbutton" v-show="showboo" ref="returnbutton">
                <div class="returnbutton-buttoin" @click="buttoinclick()"> 
                   <!-- 返回 -->
                   {{ $t('back') }}
                </div>
            </div>
        </div>        
    <!-- </div> -->
    </transition>
</template>

<script>
import eventbus from '../../common/js/eventbus.js'

export default {
  props: {
  },
  data() {
    return {
      showboo: false,
      funlist: [],
      fun: Function
    }
  },
  mounted() {
    eventbus.$on('returnfun', item => {
      this.funlist.push({fun: item})
      console.log(this.funlist)
    })
  },
  beforeDestroy () {
    eventbus.$off('returnfun')
  },
  created() {
  },
  methods: {
    show() {
      this.showboo = true
    },
    hide() {
      this.showboo = false
    },
    buttoinclick() {
      let rec = this.funlist
      if (rec.length > 0) {
        rec[rec.length - 1].fun()
        this.funlist.pop()
      }
      if (this.funlist.length === 0) {
        this.showboo = false
        this.$parent.show()
      }
    }
  },
  filters: {
  },
  components: {
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';
      .returnbutton {
            background: #00b43c;
            border-radius: 10px;
            position: fixed;
            bottom: 1px;
            z-index: 10;
            width: 98%;
            overflow: hidden;
            height: 43px; 
            right: 1%;
            &.move-enter-active, &.move-leave-active { // 动画过程
                 transition: all .5s;
                 transform: translate3d(0,0,0);
            }
            &.move-enter, &.move-leave-to { // 动画初始态
              transform: translate3d(100%,0,0);
            }
            .returnbutton-buttoin {
                line-height: 48px;
                text-align: center;
                font-size: 14px;
                font-weight: 700;
                 color: #fff;
                &.not-enough {
                    background: #2b333b;
                }
                &.enough {
                    background: #00b43c;
                    color: #fff;
                }
            }
        }
// }
</style>



// WEBPACK FOOTER //
// returnbutton.vue?202a9f36